module.exports = __webpack_public_path__ + "static/media/phone.291c6599.svg";